import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

/**
 * Generates message for Microformats section
 * @param {Object} counts - The counts object from API
 * @returns {string|null} - Message for empty state or null if data exists
 */
const generateMessage = (counts) => {
  if (!counts || Object.keys(counts).length === 0) {
    return 'No Microformats were found.';
  }
  return null;
};

/**
 * Builds table data from counts object
 * @param {Object} counts - Object with type counts like { "h-item": 3 }
 * @returns {Array} - Array of table row objects
 */
const buildMicroformatsTable = (counts) => {
  if (!counts || Object.keys(counts).length === 0) {
    return [];
  }

  return Object.entries(counts).map(([type, count]) => ({
    type: type || '',
    count: count ?? 0,
  }));
};

/**
 * Transforms the microformats criteria from WooRank API response
 * @param {Object} microformatsCriteria - The microformats criteria object from the API
 * @returns {Object} - Transformed microformats data for React components
 */
export const transformMicroformats = (microformatsCriteria) => {
  // Handle missing criteria - use 'neutral' status (maps to 'info' icon)
  if (!microformatsCriteria) {
    return {
      status: getStatus('neutral'),
      iconType: getIconType('neutral'),
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No Microformats were found.',
      data: null,
    };
  }

  const data = microformatsCriteria?.data || {};
  const wooRankStatus = microformatsCriteria?.status || 'neutral';
  const importance = microformatsCriteria?.importance || 0;
  const solvability = microformatsCriteria?.solvability || 0;

  const counts = data?.counts || {};
  const items = data?.items || [];

  const microformatsTable = buildMicroformatsTable(counts);
  const isEmpty = microformatsTable.length === 0;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: generateMessage(counts),
    data: isEmpty ? null : {
      microformatsTable,
      items,
    },
  };
};

export default transformMicroformats;

